// @flow

import React from 'react'
import { css } from '@emotion/react'

type PaginationButtonProps = {
  n: number
  current: number
  onClick: (page: number) => any
}

export default function PaginationButton({
  n,
  current,
  onClick,
}: PaginationButtonProps) {
  return n < 1 ? (
    <li className="splitter">…</li>
  ) : (
    <li
      className={
        n === current ? 'is-active pl-pagination-item' : 'pl-pagination-item'
      }
    >
      <span
        onClick={() => onClick(n)}
        css={css`
          cursor: pointer;
        `}
      >
        {n}
      </span>
    </li>
  )
}
